export default __webpack_public_path__ + "static/media/git.9cbb6a18.svg";